<template>
  <ValidationObserver ref="form">
    <b-form @submit.prevent="submitForm">
      <div>
        <label class="font-weight-bold star">Название розыгрыша</label>
        <ValidationProvider name="Название розыгрыша" rules="required|min:2" v-slot="{ errors }">
          <b-form-input
              v-model="giveawayData.name"
              placeholder="Например, Розыгрыш алмазов — эфир 05.09"
              :state="!errors.length ? null : false"
          ></b-form-input>
          <div class="text-danger">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>

      <div class="mt-4">
        <label class="font-weight-bold star">Дата старта</label>
        <ValidationProvider name="Дата старта" rules="required" v-slot="{ errors }">
          <DatePicker
              v-model="giveawayData.starts_at"
              mode="dateTime"
              is24hr
              :popover="{ visibility: 'click' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <b-form-input
                  :value="inputValue"
                  v-on="inputEvents"
                  placeholder="Выберите дату и время"
                  :state="!errors.length ? null : false"
              />
            </template>
          </DatePicker>
          <div class="text-danger">{{ errors[0] }}</div>
        </ValidationProvider>
      </div>

      <div class="mt-4">
        <label class="font-weight-bold star">Дата окончания</label>
        <ValidationProvider name="Дата окончания" rules="required" v-slot="{ errors }">
          <DatePicker
              v-model="giveawayData.ends_at"
              mode="dateTime"
              is24hr
              :min-date="giveawayData.starts_at"
              :popover="{ visibility: 'click' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <b-form-input
                  :value="inputValue"
                  v-on="inputEvents"
                  placeholder="Выберите дату и время"
                  :state="!errors.length || datesError ? null : false"
              />
            </template>
          </DatePicker>
          <div class="text-danger">{{ errors[0] || datesError }}</div>
        </ValidationProvider>
      </div>

      <div class="mt-4">
        <label class="font-weight-bold star">Количество купонов</label>
        <ValidationProvider name="Количество купонов" rules="required|min_value:1" v-slot="{ errors }">
          <b-form-input
              v-model.number="giveawayData.coupons_count"
              type="number"
              min="1"
              max="1000"
              placeholder="От 1 до 1000"
              :state="!errors.length && !couponsCountError ? null : false"
          ></b-form-input>
          <div class="text-danger">{{ errors[0] || couponsCountError }}</div>
        </ValidationProvider>
        <div class="text-muted mt-1">
          Купоны генерирует бэкенд. При увеличении числа купоны догенерируются, при уменьшении — удаляются лишние
          неактивированные (ниже количества уже активированных опустить нельзя).
        </div>
      </div>

      <div class="d-flex mt-4">
        <b-button type="submit" variant="success" :disabled="isSaving">
          {{ isSaving ? 'Сохраняем...' : submitText }}
        </b-button>
        <b-button variant="secondary" class="ml-2" :to="{ name: 'list_giveaways' }">Отмена</b-button>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import {DatePicker} from 'v-calendar';
import {ValidationObserver, ValidationProvider} from 'vee-validate';

const MAX_COUPONS_COUNT = 1000

export default {
  name: 'GiveawayForm',
  components: {DatePicker, ValidationObserver, ValidationProvider},
  props: {
    value: {
      type: Object,
      required: true
    },
    submitText: {
      type: String,
      default: 'Сохранить'
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datesError: '',
      couponsCountError: '',
    };
  },
  computed: {
    giveawayData() {
      return this.value;
    }
  },
  methods: {
    validateExtraRules() {
      this.datesError = ''
      this.couponsCountError = ''

      const {starts_at: startsAt, ends_at: endsAt, coupons_count: couponsCount} = this.giveawayData

      if (startsAt && endsAt && new Date(endsAt) <= new Date(startsAt)) {
        this.datesError = 'Дата окончания должна быть позже даты старта'
      }

      if (couponsCount > MAX_COUPONS_COUNT) {
        this.couponsCountError = `Максимум ${MAX_COUPONS_COUNT} купонов`
      }

      return !this.datesError && !this.couponsCountError
    },
    async submitForm() {
      const isValid = await this.$refs.form.validate();
      if (!this.validateExtraRules() || !isValid) {
        return;
      }

      this.$emit('submit', this.giveawayData);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/star.scss";
</style>
